module.exports = __webpack_public_path__ + "img/favorite-5.3e711929.svg";